import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import { formfields } from "kea-react";
import * as selectores from "app/features/selectores/index";
import { SelectorSimpleFactory } from "app/features/selectores/logic";

type Entity = models.BitacoraRADFiltro;

export interface Props {
    value: Entity;
    onChange: (x: Entity) => void;
}

const LimiteBitacoras = SelectorSimpleFactory([100, 200, 500], x => x, x => "" + x);

export class FiltroBitacoraComponent extends React.PureComponent<Props> {
    getField = formfields(() => this.props);

    render() {
        const getField = this.getField;
        const Datetime = getField(kea.DateTime);
        const Sucursal = getField(selectores.Sucursal);
        const Status = getField(selectores.BitacoraRADStatusSelector);
        const Limite = getField(LimiteBitacoras);
        const Text = this.getField( kea.Text );
         return (
            <div>
                {kea.autogrid(2, [
                    <Datetime field="FechaMin" label="Fecha inicio:" />,
                    <Datetime field="FechaMax" label="Fecha final:" />,
                    <Status field="Status" label="Status" />,
                    <Text field="UsuarioCreador" label="Usuario que lo elaboró" />,
                    <Sucursal field="IdSucursal" label="Sucursal que solicita:" />,
                    <Sucursal field="IdSucursalRecoleccion" label="Sucursal de recolección:" />,
                    <Limite field="Limite" label="Limite" />,                    
                ])}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/bitacoraRAD/list/filtro.tsx